export const getLockedXAxisTransformStyle = (transform: { y?: number }) => {
    if (transform?.y) {
        return { transform: `translate(0px, ${transform.y}px)` }
    }

    return {};
}